import { render, staticRenderFns } from "./audioDiv.vue?vue&type=template&id=22fe48a6&scoped=true"
import script from "./audioDiv.vue?vue&type=script&lang=js"
export * from "./audioDiv.vue?vue&type=script&lang=js"
import style0 from "./audioDiv.vue?vue&type=style&index=0&id=22fe48a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe48a6",
  null
  
)

export default component.exports